// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hi7Z","fullView":"styles_fullView__2wur1"};